import { render, staticRenderFns } from "./VehicleBookingAddMemoDialog.vue?vue&type=template&id=8f43761c&lang=pug&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./VehicleBookingAddMemoDialog.vue?vue&type=script&lang=ts&"
export * from "./VehicleBookingAddMemoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleBookingAddMemoDialog.vue?vue&type=style&index=0&id=8f43761c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports